import React from 'react';
import i18next from 'i18next';
import moment from 'moment';

const configureLocale = language => {
        i18next.init({
                // debug: process.env.NODE_ENV === 'development',
                lng: language || 'eu',
                fallbackLng: 'es',
                initImmediate: true,
                nsSeparator: false,
                keySeparator: false,
                interpolation: {
                        escapeValue: false,
                },
                returnNull: false,
                returnEmptyString: false,
                resources: {
                        eu: {translation: require('./eu/translation.json')},
                        es: {translation: require('./es/translation.json')},
                        fr: {translation: require('./fr/translation.json')},
                        en: {translation: require('./en/translation.json')},
                },
        });
        moment.locale(language);
};

export default configureLocale;

export const _ = (...args) => {
        if (typeof args[0] === 'object') {
                return args[0][getActiveLanguage()];
        }

        const splitted = (i18next.t(...args) || '').split('\n');

        if (splitted.length > 1) {
                return splitted.reduce((result, text, index) => {
                        if (index > 0) result.push(<br key={text} />);
                        result.push(text.trim());
                        return result;
                }, []);
        }
        return splitted[0];
};

export const _lazy = (...args) => () => _(...args);

const languageChangeCallbacks = [];
export const onLanguageChange = callback => {
        languageChangeCallbacks.push(callback);
};

export const getActiveLanguage = () => i18next.language;

export const setActiveLanguage = async (language) => {
        moment.locale(language);
        i18next.changeLanguage(language, () => {
                languageChangeCallbacks.forEach(callback => callback(language));
        });
};
